import React, { ReactElement } from 'react';
import Phone from '../../design-system/Phone';
import Mail from '../../design-system/Mail';
import Location from '../../design-system/Location';

const ContactArea: React.FC = (): ReactElement => (
  <div className="flex flex-col w-full h-fit lg:flex-row lg:justify-end text-secondary text-sm">
    <Phone />
    <Mail className="lg:ml-6" />
    <Location className="lg:ml-6" />
  </div>
);

export default ContactArea;
